import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { UserPreferenceEvent } from '../../../shared/models/user-favourite-event';

@Injectable()
export class UserPreferenceService {

  private preferenceEventSubject: Subject<UserPreferenceEvent>;

  constructor(private http$: HttpClient) {
    this.preferenceEventSubject = new Subject<UserPreferenceEvent>();
  }

  // Refresh left menu
  public receiveEvent(): Observable<UserPreferenceEvent> {
    return this.preferenceEventSubject.asObservable();
  }

  // setting menuItem to be updated
  public notifyEvent(event: UserPreferenceEvent) {
    this.preferenceEventSubject.next(event);
  }

  public getRecentSearchItemsList() {
    const response$ = this.http$.get('api/core/recentItems')
      .catch((error: any) => {
        return Observable.throw(error.message);
      });
    return response$;
  }

  public getAllSavedSearchCriterias() {
    const response$ = this.http$.get('api/data/loadsearch/ALL')
      .catch((error: any) => {
        return Observable.throw(error.message);
      });
    return response$;
  }

  public getAllFavorites() {
    const response$ = this.http$.get('api/core/favorites')
      .catch((error: any) => {
        if (error.error.errors.length !== 0) {
          if (error.error.errors[0].validationCode !== 200) {
            return Observable.throw(error.error.errors['0'].validationMessage);
          }
        }
      });
    return response$;
  }

  public deleteFavorites(prefrenceId: number) {
    const response$ = this.http$.post(`api/core/delete/` + prefrenceId, {})
      .catch((error: any) => {
        if (error.error.errors.length !== 0) {
          if (error.error.errors[0].validationCode !== 200) {
            return Observable.throw(error.error.errors['0'].validationMessage);
          }
        }
      });
    return response$;
  }

  public fetchTablePreferences(dataTableId: string, prefType: string): Observable<Response> {
    const dataUrl$ = this.http$
      .get(`api/core/user/tablepreferences/` + dataTableId + '/' + prefType)
      .map((response: any) => {
        if (response['prefType'] === 'FAVOURITECONFIG') {
          if (!response['configuration']) {
            response['configuration'] = { 'favourite': false };
            response['dataTableId'] = dataTableId;
            response['prefType'] = 'FAVOURITECONFIG';
            response['preferenceId'] = null;
          } else { response['configuration'] = JSON.parse(response['configuration']); }
        } else if (response['prefType'] === 'COLUMNCONFIG') {
          if (!response['configuration']) {
            response['dataTableId'] = dataTableId;
            response['prefType'] = 'COLUMNCONFIG';
            response['preferenceId'] = null;
            response['configuration'] = {
              hiddenPropertiesList: [],
              pinnedPropertiesList: [],
              columnWidthsObject: {},
              propertyIndexMap: {},
              pageDefinitionObject: {
                'sortColumn': null,
                'sortOrder': 0,
                'pageSize': 10
              }  // Page Definition Default Properties
            };
          } else {
            response['configuration'] = JSON.parse(response['configuration']);
          }
        } else if (response['prefType'] === 'COLUMNGROUPCONFIG') {
          if (!response['configuration']) {
            response['configuration'] = {};
            response['dataTableId'] = dataTableId;
            response['prefType'] = 'COLUMNGROUPCONFIG';
            response['preferenceId'] = null;
          } else {
            response['configuration'] = JSON.parse(response['configuration']);
          }
        }
        return response;
      }).catch((error: any) => {
        return Observable.throw('Failed to fetch User Preferences for '
          + dataTableId + ' :: ' + error.message);
      });
    return dataUrl$;
  }

  public saveTablePreferences(userPreferences: any) {
    // [LFWM-1897] Fix - converting userPreferences.configuration to string is needed only when the type of userPreferences.configuration is an object
    if (typeof (userPreferences.configuration) === 'object') {
      userPreferences.configuration = JSON.stringify(userPreferences.configuration);
    }
    const parseToJson = function () {
      if (typeof (userPreferences.configuration) === 'string') {
        userPreferences.configuration = JSON.parse(userPreferences.configuration);
      }
    };
    const response$ = this.http$.post(`api/core/user/tablepreferences/`, userPreferences)
      .map((response: any) => {
        parseToJson();
        return response;
      }).catch((error: any) => {
        parseToJson();
        return Observable.throw(error);
      });
    return response$;
  }

  public saveSidePanelStatus(sidePanelStatus: boolean) {
    const response$ = this.http$.post(`api/core/sidepanel/update/` + sidePanelStatus, {})
      .catch((error: any) => {
        if (error.error.errors.length !== 0) {
          if (error.error.errors[0].validationCode !== 200) {
            return Observable.throw(error.error.errors['0'].validationMessage);
          }
        }
      });
    return response$;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/layout/home/services/user-preference.service.ts